"use strict";

import React, {useContext, useEffect, useState} from 'react';
import RegisterEmailForm from "./RegisterEmailForm";
import RegisterCredentialsForm from "./RegisterCredentialsForm";
import AccountAddressForm from "../../account/component/AccountAddressForm";
import Icon from "../../component/Icon";
import RegisterContext from "../context/RegisterContext";
import Panel from "../../component/Panel";

const Register = ({onCancel=()=>{},}) => {
    const {currentStep=0, email='', password='', isCreatingAccount=false,
        isAccountCreated=false, billingDetails={}, emailIsUnique=()=>{},
        handleEmailSubmit=()=>{}, handlePasswordSubmit=()=>{},
        handleBillingDetailsSubmit=()=>{}, createAccount=()=>{},
        goToPreviousStep=()=>{},} = useContext(RegisterContext);

    useEffect(()=>{
        if(currentStep === 3) {
            createAccount().then(()=>{

            }).catch((error)=>{

            }).finally(()=>{

            });
        }
    }, [currentStep, createAccount]);

    return (
        <div>
            <h3 className="text__center">Create your Tangible Values Echeck account</h3>
            <div className="columns is-centered">
                <div className="column is-half-desktop">
                    <div className="steps is-small is-bordered">
                        <div className={`step-item is-completed is-success ${currentStep === 0 ? '' : currentStep > 0 ? 'is-completed is-success' : ''}`}>
                            <div className="step-marker">1</div>
                            <div className="step-details">
                                <p className="is-marginless">Email</p>
                            </div>
                        </div>
                        <div className={`step-item ${currentStep === 1 ? 'is-active' : currentStep > 1 ? 'is-completed is-success' : ''}`}>
                            <div className="step-marker">2</div>
                            <div className="step-details">
                                <p className="is-marginless">Password</p>
                            </div>
                        </div>
                        <div className={`step-item ${currentStep === 2 ? 'is-active' : currentStep > 2 ? 'is-completed is-success' : ''}`}>
                            <div className="step-marker">3</div>
                            <div className="step-details">
                                <p className="is-marginless">Contact Details</p>
                            </div>
                        </div>
                        <div className="steps-content is-active">
                            <div className={['text__center', currentStep === 0 ? '' : 'hide',].join(' ')}>
                                <RegisterEmailForm data={{email: email,}} onSubmit={handleEmailSubmit} onCancel={()=>{}} emailIsUnique={emailIsUnique}>
                                    <fieldset className="submit">
                                        <button type="submit"
                                                name="echeck__account__details"
                                                className="btn__primary no-wrap">
                                            Next <Icon name="right" className="icon--collapse-right" />
                                        </button>
                                    </fieldset>
                                </RegisterEmailForm>
                            </div>
                            <div className={ currentStep === 1 ? '' : 'hide'}>
                                <RegisterCredentialsForm data={{password: password,}} onSubmit={handlePasswordSubmit}>
                                    <fieldset className="submit">
                                        <div className="steps-actions">
                                            <button type="button"
                                                    name="echeck__previous__step"
                                                    className="steps-action btn btn__secondary--outline no-wrap"
                                                    style={{display: 'block',}}
                                                    onClick={goToPreviousStep} >
                                                <Icon name="left" className="icon--collapse-left" /> Previous
                                            </button>
                                            <button type="submit"
                                                    name="echeck__account__details"
                                                    className="steps-action btn__primary no-wrap"
                                                    style={{display: 'block',}}>
                                                Next <Icon name="right" className="icon--collapse-right" />
                                            </button>
                                        </div>
                                    </fieldset>
                                </RegisterCredentialsForm>
                            </div>
                            <div className={ currentStep === 2 ? '' : 'hide'}>
                                <AccountAddressForm onSubmit={ handleBillingDetailsSubmit } data={billingDetails} onCancel={ ()=>{} } >
                                    <button type="button"
                                            name="echeck__previous__step"
                                            className="btn btn__secondary--outline no-wrap"
                                            onClick={goToPreviousStep} >
                                        <Icon name="left" className="x" /> Previous
                                    </button>
                                    <button type="submit"
                                            name="echeck__account__details"
                                            className="btn__primary no-wrap">
                                        Create Account <Icon name="right" className="icon--collapse-right" />
                                    </button>
                                </AccountAddressForm>
                            </div>
                            {currentStep === 3 &&
                                <div style={{fontSize: '1rem',}}>
                                    {isAccountCreated &&
                                        <Panel type="success" iconName="success" className="is-marginless text__center" >
                                            <h4 className="">Your Account Has Been Created</h4>
                                            <p>We are redirecting to your account page</p>
                                        </Panel>
                                    }
                                    { isCreatingAccount &&
                                        <Panel type="info" iconName="loading" className="is-marginless text__center" >
                                            <h4 className="">Creating Your Account</h4>
                                        </Panel>
                                    }
                                    {!isAccountCreated && !isCreatingAccount &&
                                        <Panel type="error" iconName="warning" className="is-marginless text__center" >
                                            <h4 className="">An error occured, please try again.</h4>
                                            <a href="/echeck/register" title="Register" className="btn">
                                                Try again
                                            </a>
                                        </Panel>
                                    }
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Register;
